module.exports = __webpack_public_path__ + "static/media/fhl_my.addd033f.png";